import { api } from './client';

/**
 * Настройки приложения глазами администратора.
 *
 * ⚠️ ЧИТАТЬ МОЖНО ВСЕМ, ПРАВИТЬ — ТОЛЬКО АДМИНУ И ДИРЕКТОРУ. Открытое чтение
 * нужно самому приложению: меню и первый экран рисуются раньше, чем человек
 * вошёл. Правка идёт по отдельному адресу под проверкой роли.
 */
export type AppConfigDocument = {
  features: Record<string, boolean>;
  limits: Record<string, number>;
  texts: Record<string, Record<string, string>>;
  minVersion: Record<string, string>;
  /** С 15.10.2026; у службы до этого выката раздела нет — карточка версий тогда не даёт его сохранить. */
  latestVersion?: Record<string, string>;
  nav?: unknown[];
};

export const appConfigApi = {
  /** Читает настройки административным адресом — тем же документом. */
  get: () => api.get<AppConfigDocument>('/admin/app-config').then((r) => r.data),

  /**
   * Меняет одну настройку. Ключ плоский: `features.speaking_ai`.
   *
   * Сервер отвечает целым документом после правки — берём его как новую
   * истину, чтобы экран не расходился с сервером после гонки двух вкладок.
   */
  set: (key: string, value: unknown) =>
    api.put<AppConfigDocument>('/admin/app-config', { key, value }).then((r) => r.data),
};

/** Ключ настройки для возможности: `speaking_ai` → `features.speaking_ai`. */
export function featureConfigKey(feature: string): string {
  return `features.${feature}`;
}

/**
 * Включена ли возможность прямо сейчас.
 *
 * ⚠️ ОТСУТСТВИЕ КЛЮЧА ЗНАЧИТ «ВКЛЮЧЕНА». Настройка появляется в базе только
 * когда её тронули: у нетронутой возможности записи нет вовсе, и считать её
 * выключенной значило бы показать администратору погашенным то, что работает.
 */
export function isFeatureEnabled(doc: AppConfigDocument | undefined, feature: string): boolean {
  const v = doc?.features?.[feature];
  return v === undefined ? true : v;
}
